import { ProfileAdvancedSearchParams } from '../../profiles/search/profile-advanced-search-params.model';
import { PagedSearch } from '../../shared/model/index';
import { ReplaceEmailAddressOptionEnum } from './replace-email-address-option-enum.model';
import { ReplaceWithEmailTypeConfig } from './replace-with-email-type-config.model';
import { InvoiceAdvancedSearch } from '../../revenue/shared/invoice/invoice-advanced-search.model';

export class MessageDraftProfileSearch extends PagedSearch {
  public UnionProfileSearches: Array<ProfileAdvancedSearchParams> = [];
  public UnionInvoiceSearches: Array<InvoiceAdvancedSearch> = [];
  public ReplaceEmailAddressOption: ReplaceEmailAddressOptionEnum = ReplaceEmailAddressOptionEnum.None;

  /**
   * this option only applies when ReplaceEmailAddressOption = MainContact or BillingContact.
   * Not used when ReplaceEmailAddressOption = EmailType
   */
  public ReplaceEmailOnlyIfPrimaryEmailIsBlank: boolean = false;

  public ReplaceWithEmailTypeConfig: ReplaceWithEmailTypeConfig = new ReplaceWithEmailTypeConfig();

  /**
   * This option only applies when ReplaceEmailAddressOption = EventRegistration or EventAttendee.
   * This is required for those options.
   */
  public ReplaceEmailEventId: number = 0;

  public constructor() {
    super();
    this.OrderBy = 'ReportName:ASC';
  }
}
